import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults as SEOSegmentationProviderSearchResult } from '@/__generated__/getSearchResults';

const PROVIDER_COMMUNITIES_TYPES: Record<string, string> = {
  assistedLiving: 'Assisted living',
  continuingCare: 'Continuing care',
  independentLiving: 'Independent living',
  memoryCare: 'Memory care',
  nursingHome: 'Nursing home',
  retirementCommunity: 'Retirement community',
};
function getProviderHighlights(
  attributes: SEOSegmentationProviderSearchResult['seniorAssistedLivingCenterAttributes']
): string[] {
  if (!attributes) return [];
  const highlights = Object.entries(attributes.communityTypes)
    .filter(([item, value]) => value && PROVIDER_COMMUNITIES_TYPES[item])
    .map(([item]) => PROVIDER_COMMUNITIES_TYPES[item]);

  return [...highlights];
}

export default getProviderHighlights;
